import gql from 'graphql-tag';

export const UPDATE_PUBLICATION = gql`
  mutation (
    $id: ID!
    $publicationType: String
    $publicationAuthors: String
    $publicationTitle: String
    $publicationName: String
    $applicantRole: APPLICANT_ROLE
    $specificRole: String
    $publicationStatus: PublicationStatus
    $publicationDate: DateTime
    $issuePageArticelNo: String
    $peerReviewedIndicator: Boolean
    $citationInfo: String
    $publicationUrl: String
    $supportingDocuments: [FileTypeInput!]
  ) {
    updatePublication(
      id: $id
      input: {
        publicationType: $publicationType
        publicationAuthors: $publicationAuthors
        publicationTitle: $publicationTitle
        publicationName: $publicationName
        applicantRole: $applicantRole
        specificRole: $specificRole
        publicationStatus: $publicationStatus
        publicationDate: $publicationDate
        issuePageArticelNo: $issuePageArticelNo
        peerReviewedIndicator: $peerReviewedIndicator
        citationInfo: $citationInfo
        publicationUrl: $publicationUrl
        supportingDocuments: $supportingDocuments
      }
    ) {
      _id
    }
  }
`;
